export const CALENDAR_MODE_SWITCH_OPTIONS = [
  { label: 'Month', value: 'month' },
  { label: 'Schedule', value: 'schedule' }
]
